// extracted by mini-css-extract-plugin
export var noOverflowHidden = "_8u-0";
export var optionCard = "_8u-1";